import React from 'react';

import Layout from '../components/Layout';
import Footer from '../components/Footer';
import Scroll from '../components/Scroll';
import config from '../../config';
import pic2 from '../assets/images/pic02.jpg';
import Gallery from '../components/Gallery';
import ContactForm from '../components/ContactForm';

const savvy_images = [
  {
    src: require('../assets/images/gallery/fulls/01.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/01.jpg'),
    title: 'Savvy Apps',
    desc: 'Award-winning experiences across digital platforms.',
    full: true,
  },
  {
    src: require('../assets/images/gallery/fulls/04.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/04.jpg'),
    title: 'PetDoc',
    desc:
      'Keep your pets happy and healthy by managing their health schedules through the PetDoc app.',
  },
  {
    src: require('../assets/images/gallery/fulls/02.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/02.jpg'),
    title: 'BoatUS',
    desc: 'Boat Weather & Tides - 24/7 Boat Towing & Insurance',
  },
  {
    src: require('../assets/images/gallery/fulls/03.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/03.jpg'),
    title: 'Pocket Prep',
    desc: 'Study Anywhere, Anytime',
    full: true,
  },
];
const buzzfeed_images = [
  {
    src: require('../assets/images/gallery/fulls/07.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/07.jpg'),
    title: 'BuzzFeed',
    desc:
      'Breaking news, quizzes, videos, celeb news, Tasty food videos, DIY hacks...',
  },
  {
    src: require('../assets/images/gallery/fulls/11.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/11.jpg'),
    title: 'QuizChat',
    desc: 'Social quizzes from BuzzFeed',
  },
];
const musictown_images = [
  {
    src: require('../assets/images/gallery/fulls/06.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/06.jpg'),
    title: 'MusicTown Live',
    desc: 'Find live local music',
    full: true,
  },
  // {
  //   src: require('../assets/images/gallery/fulls/appstore-mt-1.png'),
  //   thumbnail: require('../assets/images/gallery/thumbs/appstore-mt-1.png'),
  //   title: 'MusicTown Live',
  //   desc: 'Find live local music',
  // },
  // {
  //   src: require('../assets/images/gallery/fulls/appstore-mt-2.png'),
  //   thumbnail: require('../assets/images/gallery/thumbs/appstore-mt-2.png'),
  //   title: 'MusicTown Live',
  //   desc: 'Find live local music',
  // },
  // {
  //   src: require('../assets/images/gallery/fulls/mt-wide.png'),
  //   thumbnail: require('../assets/images/gallery/thumbs/mt-wide.png'),
  //   title: 'MusicTown Live',
  //   desc: 'Find live local music',
  //   full: true,
  // },
];

const sports_squared_images = [
  {
    src: require('../assets/images/gallery/fulls/ss-mock.png'),
    thumbnail: require('../assets/images/gallery/thumbs/ss-mock.png'),
    title: 'Sports Squared',
    desc: '',
    full: true,
  },
];

const redbook_images = [
  {
    src: require('../assets/images/gallery/fulls/redbook.gif'),
    thumbnail: require('../assets/images/gallery/thumbs/redbook.gif'),
    title: 'RedBook',
    desc: '',
    full: true,
  },
];

const clubstar_images = [
  {
    src: require('../assets/images/gallery/fulls/cs-1.png'),
    thumbnail: require('../assets/images/gallery/thumbs/cs-1.png'),
    title: 'ClubStar',
    desc: 'Coming Soon',
    full: true,
  },
  // {
  //   src: require('../assets/images/gallery/fulls/cs-2.png'),
  //   thumbnail: require('../assets/images/gallery/thumbs/cs-2.png'),
  //   title: 'ClubStar',
  //   desc: 'Coming Soon',
  //   full: true,
  // },
];

const incentrip_images = [
  {
    src: require('../assets/images/gallery/fulls/inc-graphic.png'),
    thumbnail: require('../assets/images/gallery/thumbs/inc-graphic.png'),
    title: 'IncenTrip',
    desc: 'Earn reward points for each trip you plan',
    full: true,
  },
  // {
  //   src: require('../assets/images/gallery/fulls/incentrip-news.png'),
  //   thumbnail: require('../assets/images/gallery/thumbs/incentrip-news.png'),
  //   title: 'IncenTrip',
  //   desc: 'Earn reward points for each trip you plan',
  // },
];

const avnt_images = [
  {
    src: require('../assets/images/gallery/fulls/09.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/09.jpg'),
    title: 'OBTG Football Pool',
    desc: '',
    full: true,
  },
];
const img_set_4 = [
  {
    src: require('../assets/images/gallery/fulls/12.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/12.jpg'),
    title: '',
    desc: '',
  },
  {
    src: require('../assets/images/gallery/fulls/13.jpg'),
    thumbnail: require('../assets/images/gallery/thumbs/13.jpg'),
    title: '',
    desc: '',
  },
];
const IndexPage = () => (
  <Layout>
    <div id="wrapper">
      <section className="intro">
        <header>
          <h1>{config.heading}</h1>
          <p>{config.subHeading}</p>
          <ul className="actions">
            <li>
              <Scroll type="id" element="first">
                <a href="#first" className="arrow">
                  <span className="label">Next</span>
                </a>
              </Scroll>
            </li>
          </ul>
        </header>
        <div className="content">
          <span className="image fill" data-position="center">
            <div style={{ height: '12rem' }}></div>
            <div className="videoWrapper">
              <iframe
                title="portfolio video"
                src="https://www.youtube.com/embed/wvJVvuKiTB8?autoplay=1&mute=1&loop=1&showinfo=0&playlist=wvJVvuKiTB8"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </span>
        </div>
      </section>

      <section id="first">
        <header>
          <h1>Career</h1>
        </header>
        <div className="content">
          <p>
            I am a software engineer with a focus on app development! I am
            located near Washington, D.C. I have contributed to more than 10
            different apps that have appeared in the app store, some with
            hundreds of thousands of users.
          </p>
        </div>
      </section>

      <section id="first">
        <header>
          <h2>
            Uni Creative:
            <br />
            Lead Software Engineer
            <h4>2018 - 2020</h4>
          </h2>
        </header>

        <div className="content">
          <p>
            Built for inclusion,{' '}
            <strong>
              <a href="https://uni.fyi/">Uni</a>
            </strong>{' '}
            allows you to better engage those on your team and in your
            organization, and leverage their ideas and insight to shape the work
            you do.
          </p>
          <span className="image main">
            <img src={pic2} alt="" />
          </span>
        </div>
      </section>

      <section>
        <header>
          <h2>
            Savvy Apps: <br /> App Developer
            <h4>2017 - 2018</h4>
          </h2>
          <a href="https://savvyapps.com/work/pocket-prep">Pocket Prep</a>
          <br />
          <a href="https://www.boatus.com/products-and-services/app">Boat US</a>
          <br />
          <p>PetDoc</p>
        </header>
        <div className="content">
          <p>
            <strong>
              <a href="https://savvyapps.com/">Savvy Apps</a>
            </strong>{' '}
            is a creative agency that helps organizations design, build, and
            grow. Since 2009 we've worked with names like Levi's, Toyota, PBS,
            NFL Player's Association, and many others.
          </p>

          <section>
            <header></header>
            <div className="content">
              <Gallery images={savvy_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>
            BuzzFeed: <br />
            Software Engineer
            <h4>2015 - 2016</h4>
          </h2>
        </header>
        <div className="content">
          <p>
            <strong>
              <a href="https://www.buzzfeed.com">BuzzFeed</a>
            </strong>{' '}
            is an independent digital media company delivering news and
            entertainment to hundreds of millions of people around the world.
          </p>
          <section>
            <header></header>
            <div className="content">
              <Gallery images={buzzfeed_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section id="first">
        <header>
          <h1>Freelance Work</h1>
        </header>
        <div className="content"></div>
      </section>

      <section>
        <header>
          <h2>AVNT</h2>
          <br />
          <a href="https://apps.apple.com/us/app/avnt-streetwear-shopping/id1486420898?ls=1">
            iOS App Store
          </a>
          <br />
          <a href="https://play.google.com/store/apps/details?id=avntspace.avntapp">
            Google Play Store
          </a>
        </header>
        <div className="content">
          <p>
            <strong>AVNT</strong> is a community of up and coming clothing
            labels, designers and creatives from around the world. The ultimate
            source for underground streetwear.
          </p>
          <section>
            <header></header>
            <div className="content">
              <Gallery images={avnt_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>Sports Squared</h2>
          <br />
          <a href="https://apps.apple.com/us/app/sports-squared/id1495595789">
            iOS App Store
          </a>
          <br />
          <a href="https://play.google.com/store/apps/details?id=com.tarawilson.squares">
            Google Play Store
          </a>
        </header>
        <div className="content">
          <p>
            <strong>Sports Squared</strong> brings you a totally new way of
            winning prizes while watching your favorite sports games. Have you
            ever participated in the office squares for the “Big Game”? With
            Sports Squared you can get squares for all of your football and
            basketball games.
          </p>
          <section>
            <header></header>
            <div className="content">
              <Gallery images={sports_squared_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>MusicTown Live</h2>
          <a href="http://www.musictownlive.com/">Website</a>
          <br />
          <a href="https://itunes.apple.com/us/app/musique-live/id1217586564">
            iOS App Store
          </a>
          <br />
          <a href="https://play.google.com/store/apps/details?id=com.musiqueliveapp">
            Google Play Store
          </a>
        </header>
        <div className="content">
          <p>
            <strong>
              <a href="http://www.musictownlive.com/">MusicTown Live</a>
            </strong>{' '}
            helps users find live local music! You can search to find which
            artists are performing near you by date, distance, genre, venue and
            price.
          </p>

          <section>
            <header></header>
            <div className="content">
              <Gallery images={musictown_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>RedBook Night Reports</h2>

          <p>Distributed as an internal enterprise app</p>
        </header>
        <div className="content">
          <p>
            <strong>RedBook Night Reports</strong> is a hybrid app for iOS and
            Android that allows employees to easily enter and upload daily
            reports for a commercial office cleaning business.
          </p>
          <section>
            <header></header>
            <div className="content">
              <Gallery images={redbook_images} screenshots={true} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>IncenTrip</h2>
          <br />
          <a href="https://www.incentrip.org/">Website</a>
        </header>
        <div className="content">
          <p>
            <strong>
              <a href="https://www.incentrip.org/">IncenTrip</a>
            </strong>{' '}
            allows users earn reward points while receiving recommendations on
            the best travel mode, departure time and route for a trip. Users can
            exchange their reward points for gift cards or cash. IncenTrip
            analyzes and help users adopt eco-friendly driving behavior, which
            could save each user hundreds of dollars in fuel cost each year.
          </p>
          <section>
            <header></header>
            <div className="content">
              <Gallery images={incentrip_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h2>ClubStar</h2>
          <p>Coming soon!</p>
        </header>
        <div className="content">
          <section>
            <header></header>
            <div className="content">
              <Gallery images={clubstar_images} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <header>
          <h1>Skills</h1>
        </header>

        <div className="content">
          <ul>
            <li>
              <h2>Mobile Development</h2>
              <p style={{ marginTop: -40 }}>
                <strong>
                  Native iOS <br />
                </strong>
                Swift, Objective-C
              </p>
              <p style={{ marginTop: -30 }}>
                <strong>
                  Native Android <br />
                </strong>
                Kotlin, Java
              </p>
              <p style={{ marginTop: -30 }}>
                <strong>
                  Mobile Hybrid <br />
                </strong>
                React Native, Ionic
              </p>
            </li>
            <li>
              <h2>Frontend Development</h2>
              <p style={{ marginTop: -40 }}>React, Vue, Ionic, Angular</p>
            </li>
            <li>
              <h2>Backend Development</h2>
              <p style={{ marginTop: -40 }}>Django, Node/Express</p>
            </li>
          </ul>
        </div>
      </section>

      <section>
        <header>
          <h1>
            Education <br />
          </h1>
        </header>

        <div className="content">
          <ul>
            <li>
              <h2>Cornell Tech</h2>
              <p style={{ marginTop: -40 }}>
                <strong>
                  Master of Engineering in Computer Science <br />
                </strong>
                September 2014 - May 2015
                <br /> New York, NY <br />
                Received a Cornell Tech Product Impact Award for a project done
                with IMAX labs
              </p>
            </li>
            <li>
              <h2>New York University</h2>
              <p style={{ marginTop: -40 }}>
                <strong>
                  BA in Computer Science
                  <br />
                </strong>
                September 2011 - May 2014
                <br /> New York, NY <br />
                Graduated in three years with a Founder’s Day Award for academic
                achievement
              </p>
            </li>
          </ul>
          <section>
            <div className="content">
              <Gallery images={img_set_4} screenshots={false} />
            </div>
          </section>
        </div>
      </section>

      <section>
        <ContactForm />
      </section>

      <Footer />
    </div>
  </Layout>
);

export default IndexPage;
